/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatientSearchResult } from './KinnserPatientSearchResult';
import {
    KinnserPatientSearchResultFromJSON,
    KinnserPatientSearchResultFromJSONTyped,
    KinnserPatientSearchResultToJSON,
    KinnserPatientSearchResultToJSONTyped,
} from './KinnserPatientSearchResult';

/**
 * 
 * @export
 * @interface SearchKinnserPatients200Response
 */
export interface SearchKinnserPatients200Response {
    /**
     * 
     */
    data?: KinnserPatientSearchResult;
}

/**
 * Check if a given object implements the SearchKinnserPatients200Response interface.
 */
export function instanceOfSearchKinnserPatients200Response(value: object): value is SearchKinnserPatients200Response {
    return true;
}

export function SearchKinnserPatients200ResponseFromJSON(json: any): SearchKinnserPatients200Response {
    return SearchKinnserPatients200ResponseFromJSONTyped(json, false);
}

export function SearchKinnserPatients200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchKinnserPatients200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : KinnserPatientSearchResultFromJSON(json['data']),
    };
}

export function SearchKinnserPatients200ResponseToJSON(json: any): SearchKinnserPatients200Response {
    return SearchKinnserPatients200ResponseToJSONTyped(json, false);
}

export function SearchKinnserPatients200ResponseToJSONTyped(value?: SearchKinnserPatients200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': KinnserPatientSearchResultToJSON(value['data']),
    };
}

